import React from "react";
import LoadingLogo from "../../assets/loading_time.svg";
import classes from "./Homepage.module.css";
const ComingSoon = () => {
  return (
    <div className={classes.comingsoon_div}>
      <img src={LoadingLogo} alt="ComingSoon" />
      <div>
        <p className={classes.soon_text}>Coming soon...</p>
        <p>We will notify you once we have something for you</p>
      </div>
    </div>
  );
};

export default ComingSoon;
